import { SearchResultDataItem } from 'src/enterprise/ra-search';
import { DataProvider } from 'react-admin';

const addSearchMethod = (dataProvider: DataProvider) => {
    return {
        ...dataProvider,
        search: async (query: string) => {
            const resultsByResource = await Promise.all(
                ['admin/pages', 'admin/articles', 'admin/products', 'admin/orders', 'admin/users'].map(resource =>
                    searchInResource(dataProvider, resource, query)
                )
            );

            return {
                data: resultsByResource.reduce(
                    (acc, resultForResource) => [
                        ...acc,
                        ...resultForResource.data,
                    ],
                    [] as SearchResultDataItem[]
                ),
                total: resultsByResource.reduce(
                    (acc, resultForResource) =>
                        acc +
                        (resultForResource ? resultForResource.total || 0 : 0),
                    0
                ),
            };
        },
    };
};

export default addSearchMethod;

const searchInResource = async (
    dataProvider: DataProvider,
    resource: string,
    query: string
) => {
    const { data, total } = await dataProvider.getList(resource, {
        filter: { search: query }, //search
        pagination: { page: 1, perPage: 5 },
        sort: { field: 'id', order: 'ASC' },
    });

    return {
        data: await Promise.all(
            data.map(async record => ({
                id: `${resource}/${record.id}`,
                type: resource,
                url: `/${resource}/${record.id}`,
                content: await ResultBuilders[resource](record, dataProvider),
            })) as unknown as SearchResultDataItem[]
        ),
        total,
    };
};

const ResultBuilders: Record<string, any> = {
    "admin/pages": async (record: any, dataProvider: DataProvider) => {
        return record;
    },
    "admin/articles": async (record: any, dataProvider: DataProvider) => {
        return record;
    },
    "admin/products": async (record: any, dataProvider: DataProvider) => {
        return record;
    },
    "admin/orders": async (record: any) => {
        return record;
    },
    "admin/users": async (record: any) => {
        return record;
    }
};